import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface EligibleItem {
  fj510_01: string;
  fj510_11: string;
  fj510_12: string;
  fj510_13: string;
  fj510_80: string;
}

export interface SearchResponse {
  items: EligibleItem[];
  total: number;
}

export interface ExecuteResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ExecuteResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface SearchFilter {
  startNo: string;
  endNo: string;
}

// ============================================================
// API methods
// ============================================================

export const j5n4Api = {
  // POST /api/j5n4/search
  async search(filter: SearchFilter): Promise<SearchResponse> {
    const res = await apiClient.post('/api/j5n4/search', {
      start_no: filter.startNo,
      end_no: filter.endNo,
    });
    return res.data;
  },

  // POST /api/j5n4/execute
  async execute(docNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/j5n4/execute', { doc_nos: docNos, confirmed: true });
    return res.data;
  },
};
